import { initialState, IState } from 'modules/router/router.reducer';
// constants
import {
    STEP_ERROR,
    STEP_LOGIN,
    STEP_INVITEE_PAGE,
    STEP_INVITATION_PAGE,
    STEP_REFERRAL_DASHBOARD,
    STEP_PLATFORM_REGISTER,
    STEP_ERROR_NOT_ELIGIBLE,
    STEP_UBISERVICES_REQUEST_ERROR,
    STEP_ERROR_STATUS,
    STEP_END_OF_OPERATION,
    STEP_ERROR_MAINTENANCE
} from '../../router/router.constants';
import {
    ERROR_GENERAL,
    INVITEE_PAGE,
    INVITATION_PAGE,
    REFERRAL_DASHBOARD,
    PLATFORM_REGISTRATION,
    LOGIN,
    ERROR_INELIGIBLE,
    ERROR_UBISERVICES_REQUEST,
    ERROR_CAMPAIGN_STATUS,
    END_OF_OPERATION,
    ERROR_MAINTENANCE
} from '../../states/states.constants';
import { SWITCH_PREVIEW_STATE_HOST, SwitchPreviewStateAction } from '@sitegen/common/types/root-actions';

export const router = (state = initialState, action: SwitchPreviewStateAction): IState => {
    switch (action.type) {
    case SWITCH_PREVIEW_STATE_HOST: {
        switch (action.payload) {
        case LOGIN:
            return {
                currentView: STEP_LOGIN
            };
        case ERROR_GENERAL:
            return {
                currentView: STEP_ERROR
            };
        case ERROR_INELIGIBLE:
            return {
                currentView: STEP_ERROR_NOT_ELIGIBLE
            };
        case ERROR_UBISERVICES_REQUEST:
            return {
                currentView: STEP_UBISERVICES_REQUEST_ERROR
            };
        case ERROR_CAMPAIGN_STATUS:
            return {
                currentView: STEP_ERROR_STATUS
            };
        case ERROR_MAINTENANCE:
            return {
                currentView: STEP_ERROR_MAINTENANCE
            };
        case INVITEE_PAGE:
            return {
                currentView: STEP_INVITEE_PAGE
            };
        case INVITATION_PAGE:
            return {
                currentView: STEP_INVITATION_PAGE
            };
        case PLATFORM_REGISTRATION:
            return {
                currentView: STEP_PLATFORM_REGISTER
            };
        case REFERRAL_DASHBOARD:
            return {
                currentView: STEP_REFERRAL_DASHBOARD
            };
        case END_OF_OPERATION:
            return {
                currentView: STEP_END_OF_OPERATION
            };
        default:
            return state;
        }
    }
    default:
        return state;
    }
};

export default router;
